"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var ety = require("../../enumeration-type");
var DeliverableCriteria = /** @class */ (function () {
    function DeliverableCriteria() {
    }
    return DeliverableCriteria;
}());
exports.DeliverableCriteria = DeliverableCriteria;
var DeliverableCriteriaHelper = /** @class */ (function () {
    function DeliverableCriteriaHelper() {
    }
    DeliverableCriteriaHelper.convertDeliverableCriteriasToURLSearchParam = function (criterias) {
        var delCriteriasSerialized = DeliverableCriteriaHelper.serializeUrlStringList(criterias);
        var delCriteriasParams = DeliverableCriteriaHelper.buildURLSearchParams(delCriteriasSerialized);
        return delCriteriasParams;
    };
    DeliverableCriteriaHelper.buildURLSearchParam = function (criteria) {
        var params = new http_1.HttpParams();
        var criteriaComponents = criteria.split('=');
        if (criteriaComponents.length == 2)
            params.set(criteriaComponents[0], criteriaComponents[1]);
        return params;
    };
    DeliverableCriteriaHelper.buildURLSearchParams = function (criterias) {
        var params = new http_1.HttpParams();
        if (criterias && criterias.length >= 1) {
            criterias.forEach(function (criteria) {
                var criteriaComponents = criteria.split('=');
                if (criteriaComponents.length == 2)
                    params.set(criteriaComponents[0], criteriaComponents[1]);
            });
        }
        return params;
    };
    DeliverableCriteriaHelper.serializeUrlString = function (criteria) {
        var value = this.getValue(criteria);
        if (value)
            return criteria.criteriaTarget.id + "." + criteria.field.id + "=" + value;
        return null;
    };
    DeliverableCriteriaHelper.serializeUrlStringList = function (criterias) {
        var _this = this;
        if (criterias && criterias.length >= 1) {
            var values = criterias.map(function (criteria) { return _this.serializeUrlString(criteria); });
            if (values && values.length >= 1)
                return values;
            return null;
        }
        return null;
    };
    DeliverableCriteriaHelper.getValue = function (criteria) {
        if (!this.isObject(criteria.value))
            return criteria.value.toString();
        if (criteria.value instanceof ety.UnitType
            || criteria.value instanceof ety.AssignableProductType
            || criteria.value instanceof ety.WorkReadyStatus
            || criteria.value instanceof ety.ObjectType)
            return criteria.value.id;
        return null;
    };
    DeliverableCriteriaHelper.isObject = function (value) {
        var type = typeof value;
        return value != null && (type == 'object' || type == 'function');
    };
    return DeliverableCriteriaHelper;
}());
exports.DeliverableCriteriaHelper = DeliverableCriteriaHelper;
var DeliverableOrPhaseCriteria = /** @class */ (function (_super) {
    __extends(DeliverableOrPhaseCriteria, _super);
    function DeliverableOrPhaseCriteria() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeliverableOrPhaseCriteria;
}(DeliverableCriteria));
exports.DeliverableOrPhaseCriteria = DeliverableOrPhaseCriteria;
var OwnerCriteria = /** @class */ (function (_super) {
    __extends(OwnerCriteria, _super);
    function OwnerCriteria() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OwnerCriteria;
}(DeliverableCriteria));
exports.OwnerCriteria = OwnerCriteria;
var ParentCriteria = /** @class */ (function (_super) {
    __extends(ParentCriteria, _super);
    function ParentCriteria() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ParentCriteria;
}(DeliverableCriteria));
exports.ParentCriteria = ParentCriteria;
var SelectCriteria = /** @class */ (function () {
    function SelectCriteria() {
    }
    return SelectCriteria;
}());
exports.SelectCriteria = SelectCriteria;
var SelectCriteriaHelper = /** @class */ (function () {
    function SelectCriteriaHelper() {
    }
    SelectCriteriaHelper.convertSelectCriteriasToURLSearchParam = function (criterias) {
        var selCriteriasSerialized = SelectCriteriaHelper.serializeUrlStringList(criterias);
        var selCriteriasParams = SelectCriteriaHelper.buildURLSearchParams(selCriteriasSerialized);
        return selCriteriasParams;
    };
    SelectCriteriaHelper.buildURLSearchParam = function (criteria) {
        var params = new http_1.HttpParams();
        var criteriaComponents = criteria.split('=');
        if (criteriaComponents.length == 2)
            params.set(criteriaComponents[0], criteriaComponents[1]);
        return params;
    };
    SelectCriteriaHelper.buildURLSearchParams = function (criterias) {
        var params = new http_1.HttpParams();
        if (criterias && criterias.length >= 1) {
            criterias.forEach(function (criteria) {
                var criteriaComponents = criteria.split('=');
                if (criteriaComponents.length == 2)
                    params.set(criteriaComponents[0], criteriaComponents[1]);
            });
        }
        return params;
    };
    SelectCriteriaHelper.serializeUrlString = function (criteria) {
        var value = this.getValue(criteria);
        if (value)
            return criteria.criteriaTarget.id + "." + criteria.field.id + "=" + value;
        return null;
    };
    SelectCriteriaHelper.serializeUrlStringList = function (criterias) {
        var _this = this;
        if (criterias && criterias.length >= 1) {
            var values = criterias.map(function (criteria) { return _this.serializeUrlString(criteria); });
            if (values && values.length >= 1)
                return values;
            return null;
        }
        return null;
    };
    SelectCriteriaHelper.getValue = function (criteria) {
        if (!this.isObject(criteria.value))
            return criteria.value.toString();
        if (criteria.value instanceof ety.SelectCriteriaObjectType)
            return criteria.value.id;
        return null;
    };
    SelectCriteriaHelper.isObject = function (value) {
        var type = typeof value;
        return value != null && (type == 'object' || type == 'function');
    };
    return SelectCriteriaHelper;
}());
exports.SelectCriteriaHelper = SelectCriteriaHelper;
